import React, { useEffect, useState } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import { ReactComponent as BackArrow } from "../../Icons/BorderBackArrow.svg";
import {
  Avatar,
  Grid,
  Divider,
  Skeleton,
  Tabs,
  Tab,
} from "@mui/material";
import {
  Box,
  Button,
  Checkbox,
  Menu,
  MenuItem,
  Modal,
  OutlinedInput,
  Pagination,
  CircularProgress,
  PaginationItem,
  Select,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  tableCellClasses,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Switch,
} from "@mui/material";
import {
  DatePickerStyle,
  PrimaryTypography,
  SecondaryTypography,
  StyledOutlinedInput,
  StyledSecondaryTypography,
  StyledTableCell,
  StyledTableRow,
  StyledTypography,
  TypographyDefault,
} from "../../Theme";
import { ReactComponent as SearchIcon } from "../../Icons/Search.svg";
import { ReactComponent as FilterIcon } from "../../Icons/Filter.svg";
import { ReactComponent as SortIcon } from "../../Icons/Sort.svg";
import { ReactComponent as CsvIcon } from "../../Icons/CsvIcon.svg";
import { ReactComponent as PdfIcon } from "../../Icons/PdfIcon.svg";
import { ReactComponent as DownloadIcon } from "../../Icons/DownloadIcon.svg";
import { ReactComponent as NumberInputIcon } from "../../Icons/NumberInputIcon.svg";
import { ReactComponent as CheckboxIcon } from "../../Icons/Checkbox.svg";
import { ReactComponent as DeleteIcon } from "../../Icons/DeleteTable.svg";
import { ReactComponent as PreviousIcon } from "../../Icons/Previous.svg";
import { ReactComponent as NextIcon } from "../../Icons/Next.svg";
import { ReactComponent as ExclamatoryIcon } from "../../Icons/Exclamatory.svg";
import { ReactComponent as MoreIcon } from "../../Icons/ThreeDot.svg";
import { ReactComponent as Close } from "../../Icons/BorderAlertClose.svg";
import { ReactComponent as DisabledDownloadIcon } from "../../Icons/DisableDownload.svg";
import { ReactComponent as DatePickerIcon } from "../../Icons/Datepicker.svg";
import { UserAllTabColumn, UserAllTabColumn1 } from "../../Data";
import { saveAs } from "file-saver";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import axiosInstance from "../../Redux/AxiosInstance";
import moment from "moment";
import { getChip } from "../../Utils";
import TypesInformationModal from "../../CommonComponents/TypeInformationModal";
import { DatePicker } from "@mui/x-date-pickers";
import { showToast } from "../../CommonComponents/Toaster";
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import AlertModal from "../../CommonComponents/modal";
import { toast, ToastContainer } from "react-toastify";
import parsePhoneNumberFromString from "libphonenumber-js";

const reviewstyle = {
  minHeight: "61px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  padding: "10px 0",
};

function stringToColor(string) {
  // Array of colors
  const colors = ["#EBE1CE", "#009C70", "#800000", "#FEE4E2"];

  // Generate a hash based on the string to choose an index for the colors array
  let hash = 0;
  for (let i = 0; i < string.length; i++) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  // Use the hash to pick a color from the array (modulo operation ensures the index is within bounds)
  const colorIndex = Math.abs(hash) % colors.length;

  return colors[colorIndex];
}

function stringAvatar(name) {
  if (/\s/.test(name)) {
    return {
      sx: {
        bgcolor: stringToColor(name),
        color: stringToColor(name) === "#800000" ? "white" : "#111927",
      },
      children: `${name.split(" ")[0][0]}${name.split(" ")[1][0]}`,
    };
  } else {
    return {
      sx: {
        bgcolor: stringToColor(name),
        color: stringToColor(name) === "#800000" ? "white" : "#111927",
      },
      children: `${name.split(" ")[0][0]}`,
    };
  }
}

const TabPanel = ({ children, value, index, ...other }) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`organization-tabpanel-${index}`}
      aria-labelledby={`organization-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ pt: 3 }}>{children}</Box>}
    </div>
  );
};

const ViewOrganization = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();
  const { state } = location;
  const { data } = state || {};
  console.log("data", data);
  const [visitors, setvisitors] = useState([]);
  const [block, setblock] = useState({
    wovisitor: false,
    wvisitor: false,
    selfregister: false,
  });
  const { propertyId } = useSelector((state) => state.PropertyDetails);
  const [loading, setloading] = useState(true);
   const [tabValue, setTabValue] = useState(() => {
    try {
      const savedTabValue = localStorage.getItem('organizationViewTab');
      return savedTabValue !== null ? parseInt(savedTabValue, 10) : 0;
    } catch (error) {
      console.error("Error reading from localStorage:", error);
      return 0;
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem('organizationViewTab', tabValue.toString());
    } catch (error) {
      console.error("Error saving to localStorage:", error);
    }
  }, [tabValue]);

  const [initialRender, setInitialRender] = useState(true);
    const tabList = ["All", "Active", "Inactive"];
    const { userDetails } = useSelector((state) => state.Login);
    console.log(userDetails)
    const [TabId, setTabId] = useState("");
    console.log(TabId);
    const [currentPage, setCurrentPage] = useState(1);
    const [selectedTab, setSelectedTab] = useState("All");
    const [VisitorsList, setVisitorsList] = useState([]);
    const [rowsPerPage, setRowsPerPage] = useState("10");
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const [sortAnchorEl, setSortAnchorEl] = useState(null);
    const sortOpen = Boolean(sortAnchorEl);
    const [sortData, setSortData] = useState(null);
    const [filterAnchorEl, setFilterAnchorEl] = useState(null);
    const filterOpen = Boolean(filterAnchorEl);
    const [paginationData, setPaginationData] = useState({});
    const [showAnchorEl, setshowAnchorEl] = useState(null);
    const showOpen = Boolean(showAnchorEl);
    const [SearchData, setSearchData] = useState("");
    const [Tableloading, setTableloading] = useState(true);
    const [showDeleteModal, setshowDeleteModal] = useState(false);
    const [selectedDevice, setSelectedDevice] = useState(null);
    const [openStatusModal, setOpenStatusModal] = useState(false);
    const [selectedStatusItem, setSelectedStatusItem] = useState(null);
    const [newStatus, setNewStatus] = useState(null); // true/false
  
  
    const userRoles = {
      '2' : 'BMO Admin',
      '3' : 'Concierge',
      '4' : 'Security',
      '5' : 'Company',
    }
  
    let name ="";
    let deleteModalDatas = {
      label:  "Delete User",
      descriptionOne:  `User will be removed from the list.`,
      buttonOne: {
        variant: "outlined",
        color: "#800000",
        backgroundColor: "#FFFFFF",
        text: "Cancel",
      },
      buttonTwo: {
        variant: "contained",
        color: "#FFFFFF",
        backgroundColor: "#B42318",
        text: "Delete Now",
      },
    };
  
  
  const formatPhone = (number) => {
    if (!number) return "-";
  
    // Add + if missing
    const normalized = number.startsWith("+") ? number : `+${number}`;
  
    const phone = parsePhoneNumberFromString(normalized);
    return phone ? phone.formatInternational() : normalized;
  };
  
  const getAllVisitors = async () => {
    setTableloading(true)
      try {
          const response = await axiosInstance.get(`${process.env.REACT_APP_API_URL}list_company_users?page=${currentPage}&per_page=${rowsPerPage}&user_id=${userDetails.id}&role_id=${userDetails.user_role}&company_id=${id || null}&searchdata=${SearchData}&is_user_active=${selectedTab == "All" ? null : selectedTab == "Active" ? true : false}`);
          console.log(response)
          if(response.status === 200){
              setVisitorsList(response.data.data);
              setPaginationData(response.data.pagination_details);
          }
          setTableloading(false);
      } catch (error) {
          console.log(error.response.status, 'list devices')
          if(error?.response?.status === 404){
              setVisitorsList([]);
          }
          setTableloading(false);
      }
  }
  
  console.log(paginationData)
    useEffect(() => {
      getAllVisitors();
    }, [currentPage]);
  
    useEffect(() => {
      if (!initialRender) {
        if (currentPage != 1) {
          setCurrentPage(1);
        } else {
          getAllVisitors();
        }
      } else {
        setInitialRender(false);
      }
    }, [TabId, sortData, rowsPerPage, SearchData]);
  
    const DownloadReport = async (type) => {
      try {
        setloading(true)
        setAnchorEl(false);
        const response = await axiosInstance.get(
          `${process.env.REACT_APP_API_URL}invite_visitor/property/${propertyId}/download?download_type=${type}`,
          { responseType: "blob" }
        );
        saveAs(response.data, `Visitors_report.${type}`);
      } catch (error) {
        console.log(error);
        showToast("Something went wrong! Please try again.", "error");
      } finally {
        setloading(false)
      }
    };
  
    const getColumnType = () => {
      switch (selectedTab) {
        case "All":
          return userDetails?.user_role === 2 ? UserAllTabColumn1 : UserAllTabColumn;
        case "Active":
          return userDetails?.user_role === 2 ? UserAllTabColumn1 : UserAllTabColumn;
        case "Inactive":
          return userDetails?.user_role === 2 ? UserAllTabColumn1 : UserAllTabColumn;
        default:
          return [];
      }
    };
  
    const getNoDataType = () => {
      switch (selectedTab) {
        case "All":
          return (
            <>
              <ExclamatoryIcon />
              <Typography
                sx={{
                  color: "#9DA4AE",
                  fontSize: "16px",
                  fontWeight: 600,
                  my: 2,
                }}
              >
                No User History
              </Typography>
              {/* <StyledSecondaryTypography color="#9DA4AE !important">
                There are no pending, active or past visitors in the system at the
                moment.{" "}
              </StyledSecondaryTypography> */}
            </>
          );
        case "Active":
          return (
            <>
              <ExclamatoryIcon />
              <Typography
                sx={{
                  color: "#9DA4AE",
                  fontSize: "16px",
                  fontWeight: 600,
                  my: 2,
                }}
              >
                No Active Users found.
              </Typography>
              {/* <StyledSecondaryTypography color="#9DA4AE !important">
                There are no pending, active or past visitors in the system at the
                moment.{" "}
              </StyledSecondaryTypography> */}
            </>
          );
        case "Inactive":
          return (
            <>
              <ExclamatoryIcon />
              <Typography
                sx={{
                  color: "#9DA4AE",
                  fontSize: "16px",
                  fontWeight: 600,
                  my: 2,
                }}
              >
                No Inactive Users found.
              </Typography>
              {/* <StyledSecondaryTypography color="#9DA4AE !important">
                There are no pending, active or past visitors in the system at the
                moment.{" "}
              </StyledSecondaryTypography> */}
            </>
          );
        default:
          return [];
      }
    };
  
    console.log(selectedStatusItem)
    console.log(VisitorsList)
    const handleConfirmToggle = async () => {
      try {
        await axiosInstance.put(
          `${process.env.REACT_APP_API_URL}user_status/${selectedStatusItem.id}?updater_email=${userDetails?.email}&role_id=${userDetails?.user_role}`,
          { is_active: String(newStatus) }
        );
    
        // Update UI instantly
        setVisitorsList((prev) =>
          prev.map((row) =>
            row.id === selectedStatusItem.id
              ? { ...row, is_user_active: newStatus }
              : row
          )
        );
    
        setOpenStatusModal(false); // close modal
        setSelectedStatusItem(null);
      } catch (error) {
        console.error("Status update failed", error);
        alert("Failed to update status");
      }
    };
    
  
    const renderData = (value, index) => {
      const serialNumber = (currentPage - 1) * rowsPerPage + (index + 1);
      // switch (selectedTab) {
      //   case 'All':
      return (
        <StyledTableRow height="70px">
          <StyledTableCell style={{ width: '6%'  }}
          //   onClick={() => navigate(`visitorsDetails/${value.id}`)}
          >
            <StyledSecondaryTypography>
              {serialNumber}
            </StyledSecondaryTypography>
          </StyledTableCell>
          <StyledTableCell
          //   onClick={() => navigate(`visitorsDetails/${value.id}`)}
          >
            <StyledSecondaryTypography>
              {value?.name || "-"}
            </StyledSecondaryTypography>
          </StyledTableCell>
          <StyledTableCell
          //   onClick={() => navigate(`visitorsDetails/${value.id}`)}
          >
            <StyledSecondaryTypography>
            {value?.email || "-"}
            </StyledSecondaryTypography>
          </StyledTableCell>
          <StyledTableCell
          //   onClick={() => navigate(`visitorsDetails/${value.id}`)}
          >
            <StyledSecondaryTypography>
            {formatPhone(value?.phone) || "-"}
            </StyledSecondaryTypography>
          </StyledTableCell>
          <StyledTableCell
          //   onClick={() => navigate(`visitorsDetails/${value.id}`)}
          >
            <StyledSecondaryTypography>
            {value?.sub_user_role || userRoles[value?.role_id]}
            </StyledSecondaryTypography>
          </StyledTableCell>
          {userDetails?.user_role !== 2 && (
          <StyledTableCell
          //   onClick={() => navigate(`visitorsDetails/${value.id}`)}
          >
            <StyledSecondaryTypography>
            {value?.company_name || "-"}
            </StyledSecondaryTypography>
        
            
  
          </StyledTableCell>
          )}
          <StyledTableCell
          //   onClick={() => navigate(`visitorsDetails/${value.id}`)}
          >
            <IconButton onClick={() => navigate(`edit_user/${value?.id}`, {state: {deviceData : value}})}>
              <ModeEditIcon />
            </IconButton>
            {/* <IconButton onClick={() => {
              setSelectedDevice(value)
              setshowDeleteModal(true);
            }}>
              <DeleteIcon />
            </IconButton> */}
            <Switch
              checked={value?.is_user_active}
              onChange={() => {
                setSelectedStatusItem(value);
                setNewStatus(!value.is_user_active); // toggled value
                setOpenStatusModal(true);
              }}
              color="primary"
            />
          </StyledTableCell>
        </StyledTableRow>
      );
      // }
    };
  
    const handleShowDeleteModal = () => {
    setshowDeleteModal(!showDeleteModal);
  };
  
    const deleteDevice = async () => {
     try {
       const response = await axiosInstance.delete(`${process.env.REACT_APP_API_URL}delete_user/${selectedDevice?.id}?deleter_email=${userDetails?.email}`);
       if (response.status === 200) {
         toast.success("User deleted successfully");
         handleShowDeleteModal()
         getAllVisitors();
       }
     } catch (error) {
       console.log(error);
        toast.error("Something went wrong! Please try again.");
    }
    }

  useEffect(() => {
    if (data) {
      setvisitors(data);
      setloading(false);

      setblock({
        wovisitor: true,
        wvisitor: true,
        selfregister: false,
      });
    }
  }, [data]);



  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  console.log("visitors", visitors);

  return (
    <>
    {showDeleteModal && (
                        <AlertModal
                          modalDatas={deleteModalDatas}
                          confirmFunction={deleteDevice}
                          name={name}
                          closeFunction={handleShowDeleteModal}
                        />
                      )}
      <Box p={5} sx={{ backgroundColor: "#F3F4F6" }}>
        <Stack direction="row" justifyContent="space-between">
          <BackArrow
            onClick={() => navigate(-1)}
            style={{ marginBottom: "26px", cursor: "pointer" }}
          />
        </Stack>
        
        {loading ? (
          <Skeleton variant="rounded" width="100%" height="50vh" />
        ) : (
          <>
            {/* Tabs Header */}
            <Box
              component="div"
              boxShadow="0 0 3px 0 rgba(0 ,0 ,0 ,0.1)"
              borderRadius="8px"
              sx={{ backgroundColor: "white", height : '64px' }}
            >
              <Tabs
                value={tabValue}
                onChange={handleTabChange}
                aria-label="organization tabs"
                sx={{
                  borderBottom: 1,
                  borderColor: "divider",
                  minHeight: "64px",   // 👈 tabs container height
                  "& .MuiTab-root": {
                    minHeight: "64px", // 👈 each tab height
                    height: "64px",
                    textTransform: "none",
                    fontSize: "16px",
                    fontWeight: 500,
                    paddingY: "12px",  // optional spacing
                  },
                  "& .Mui-selected": {
                    color: "#800000",
                  },
                  "& .MuiTabs-indicator": {
                    backgroundColor: "#800000",
                    height: "3px", // optional thicker indicator
                  },
                }}
              >
                {block?.wovisitor && (
                  <Tab
                    label="Organization Details"
                    id="organization-tab-0"
                    aria-controls="organization-tabpanel-0"
                  />
                )}
                {block?.wvisitor && (
                  <Tab
                    label="User Details"
                    id="organization-tab-1"
                    aria-controls="organization-tabpanel-1"
                  />
                )}
              </Tabs>
            </Box>

            {/* Organization Details Tab */}
            {block?.wovisitor && (
              <TabPanel value={tabValue} index={0}>
                <Box
                  component="div"
                  boxShadow="0 0 3px 0 rgba(0 ,0 ,0 ,0.1)"
                  borderRadius="8px"
                >
                  {/* <Stack
                    direction="row"
                    alignItems="center"
                    px="16px"
                    sx={{
                      height: "66px",
                      backgroundColor: "#FCFCFD",
                      border: "1px solid #E5E7EB",
                      borderRadius: "8px 8px 0 0 ",
                    }}
                  >
                    <SecondaryTypography>Organization Details</SecondaryTypography>
                  </Stack> */}
                  <Grid
                    container
                    xs={12}
                    gap="2.8%"
                    sx={{
                      backgroundColor: "white",
                      padding: "30px 16px 30px 16px",
                      border: "1px solid #E5E7EB",
                      borderRadius: "0 0 8px 8px  ",
                    }}
                  >
                    <Grid xs={12} sm={5.8} sx={reviewstyle}>
                      <StyledSecondaryTypography>
                        Company Name
                      </StyledSecondaryTypography>
                      <TypographyDefault>
                        {visitors?.company_name || "-"}
                      </TypographyDefault>
                    </Grid>
                    <Grid xs={12} sm={5.8} sx={reviewstyle}>
                      <StyledSecondaryTypography>
                        Email
                      </StyledSecondaryTypography>
                      <TypographyDefault>
                        {visitors?.email || "-"}
                      </TypographyDefault>
                    </Grid>
                    <Grid xs={12} sm={5.8} sx={reviewstyle}>
                      <StyledSecondaryTypography>
                        Host Name
                      </StyledSecondaryTypography>
                      <TypographyDefault>
                        {visitors?.name || "-"}
                      </TypographyDefault>
                    </Grid>
                    <Grid xs={12} sm={5.8} sx={reviewstyle}>
                      <StyledSecondaryTypography>
                        Address
                      </StyledSecondaryTypography>
                      <TypographyDefault>
                        {visitors?.address || "-"}
                      </TypographyDefault>
                    </Grid>
                    <Grid xs={12} sm={5.8} sx={reviewstyle}>
                      <StyledSecondaryTypography>
                        Level
                      </StyledSecondaryTypography>
                      <TypographyDefault>
                        {visitors?.level || "-"}
                      </TypographyDefault>
                    </Grid>
                    <Grid xs={12} sm={5.8} sx={reviewstyle}>
                      <StyledSecondaryTypography>
                        Unit
                      </StyledSecondaryTypography>
                      <TypographyDefault>
                        {visitors?.unit || "-"}
                      </TypographyDefault>
                    </Grid>
                    <Grid xs={12} sm={5.8} sx={reviewstyle}>
                      <StyledSecondaryTypography>
                        Phone
                      </StyledSecondaryTypography>
                      <TypographyDefault>
                        {formatPhone(visitors?.phone) || "-"}
                      </TypographyDefault>
                    </Grid>
                    
                    <Divider
                      sx={{
                        borderTop: "1px solid #F3F4F6",
                        width: "100%",
                        marginTop: "10px",
                      }}
                    />
                  </Grid>
                </Box>
              </TabPanel>
            )}

            {/* User Details Tab */}
            {block?.wvisitor && (
              <TabPanel value={tabValue} index={block?.wovisitor ? 1 : 0}>
                <ToastContainer
                                      autoClose='3000'
                                      position="bottom-center"
                                      toastClassName="custom-toast"
                                      hideProgressBar={true}
                                    />
                    
                      <Box sx={{ display: "flex", justifyContent: "space-between", mt : 2 }}>
                        <Box>
                          <PrimaryTypography>User List</PrimaryTypography>
                          {/* <StyledSecondaryTypography>
                            View a list of all visitor invitations and registrations made via
                            the LOBY system.{" "}
                          </StyledSecondaryTypography> */}
                        </Box>
                        {/* <Button
                          onClick={(e) => setAnchorEl(e.currentTarget)}
                          sx={{
                            fontWeight: "600",
                            width: "fit-content",
                            color: "#800000",
                            backgroundColor: "#E7EFF3",
                            padding: "10px 16px 10px 16px",
                            "&:hover": {
                              backgroundColor: "#CFDFE6",
                            },
                            "&.Mui-disabled": {
                              backgroundColor: "#F9FAFB",
                              color: "#D2D6DB",
                            },
                          }}
                          disabled={VisitorsList.length === 0 || loading}
                        >
                          {loading ? (
                            <Box sx={{ width: "40px", marginTop: "5px" }}>
                              <CircularProgress size={15} />
                            </Box>
                          ) : VisitorsList.length > 0 ? (
                            <DownloadIcon style={{ marginRight: "8px", padding: "3px" }} />
                          ) : (
                            <DisabledDownloadIcon
                              style={{ marginRight: "8px", padding: "3px" }}
                            />
                          )}
                          Download Report
                        </Button> */}
                         <Button
                                onClick={() => navigate('add_user')}
                                // variant="contained"
                                // height="40px"
                                sx={{
                                  height: "40px",
                                  padding: "10px 16px",
                                  borderRadius: "8px",
                                  backgroundColor: "#800000",
                                  color: "#FFF",
                                  fontSize: "14px",
                                  fontWeight: 600,
                                  "&:hover": {
                                    backgroundColor: "#800000",
                                  },
                                }}
                              >
                                {"Add"}
                              </Button>
                      </Box>
                
                      <Box
                        sx={{
                          backgroundColor: "#FFFFFF",
                          border: "1px solid #E5E7EB",
                          p: 3,
                          mt: 4,
                          borderRadius: " 8px 8px 0px 0px",
                          display: "flex",
                          justifyContent: "space-between",
                          overflowX: "scroll",
                          "::-webkit-scrollbar": { display: "none" },
                        }}
                      >
                        <Box
                          sx={{
                            border: "1px solid #D2D6DB",
                            display: "flex",
                            borderRadius: "10px",
                          }}
                        >
                          {tabList.map((value, index) => (
                            <Box
                              onClick={() => {
                                setSelectedTab(value);
                                setTabId(index == 0 ? "" : index);
                              }}
                              sx={{
                                borderLeft: index !== 0 ? "1px solid #E5E7EB" : "initial",
                                backgroundColor: value == selectedTab ? "#F3F4F6" : "initial",
                                padding: "10px 16px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                borderRadius:
                                  index == 0
                                    ? " 8px 0 0 8px "
                                    : index == 2
                                    ? "0px 8px 8px 0px"
                                    : "initial",
                                "&:hover": { cursor: "pointer" },
                              }}
                            >
                              <Typography
                                sx={{
                                  color: value === selectedTab ? "#111927" : "#4D5761",
                                  fontSize: "14px",
                                  fontWeight: 550,
                                }}
                                textAlign={"center"}
                              >
                                {value}
                              </Typography>
                            </Box>
                          ))}
                        </Box>
                        <Box sx={{ display: "flex", height: "40px" }}>
                          <StyledOutlinedInput
                            placeholder="Search"
                            onChange={(e) => {
                              setSearchData(e.target.value);
                            }}
                            startAdornment={<SearchIcon style={{ paddingRight: "5px" }} />}
                          />
                          {/* <Box
                            onClick={(e) => setSortAnchorEl(e.currentTarget)}
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              border: "1px solid #D2D6DB",
                              borderRadius: "6px",
                              px: 2,
                              ml: 2,
                              "&:hover": { cursor: "pointer", backgroundColor: "#F9FAFB" },
                            }}
                          >
                            <SortIcon style={{ marginRight: "10px" }} />
                            <SecondaryTypography>Sort</SecondaryTypography>
                          </Box>
                          <Box onClick={(e) => setFilterAnchorEl(e.currentTarget)} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', border: '1px solid #E5E7EB', borderRadius: '6px', px: 2, ml: 2 }}>
                            <FilterIcon style={{ marginRight: '10px' }} />
                            <SecondaryTypography>Filters</SecondaryTypography>
                          </Box> */}
                        </Box>
                      </Box>
                
                      <Box
                        sx={{ border: "1px solid #E5E7EB", borderRadius: "0px 0px 8px 8px", mt : 0 }}
                      >
                        <>
                          <TableContainer>
                            {Tableloading ? (
                              <Box sx={{ display: "flex", justifyContent: "center" }}>
                                <CircularProgress style={{ margin: "20px" }} />
                              </Box>
                            ) : (
                 <Table>
                              <TableHead>
                                {VisitorsList?.length > 0 && (
                                  <StyledTableRow>
                                    {getColumnType().map((value) => {
                                      return (
                                        <StyledTableCell>
                                          {value === "Checkbox" ? (
                                            <Checkbox size="small" icon={<CheckboxIcon />} />
                                          ) : value === "More" ? (
                                            ""
                                          ) : (
                                            value
                                          )}
                                        </StyledTableCell>
                                      );
                                    })}
                                  </StyledTableRow>
                                )}
                              </TableHead>
                              <TableBody bgColor={!VisitorsList.length > 0 && "#F9FAFB"}>
                                {VisitorsList?.length > 0 ? (
                                  VisitorsList?.map((value, index) => {
                                    return renderData(value, index);
                                  })
                                ) : (
                                  <Box
                                    sx={{
                                      display: "flex",
                                      flexDirection: "column",
                                      alignItems: "center",
                                      height: "50vh",
                                      justifyContent: "center",
                                    }}
                                  >
                                    {Tableloading ? <CircularProgress /> : getNoDataType()}
                                  </Box>
                                )}
                              </TableBody>
                            </Table>
                            )}
                           
                          </TableContainer>
                
                          {!Tableloading && VisitorsList?.length > 0 && (
                            <Box
                              sx={{
                                backgroundColor: "#FFFFFF",
                                borderTopStyle: "none !important",
                                // border: "1px solid #E5E7EB",
                                borderRadius: "0px 0px 8px 8px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                p: 2.5,
                              }}
                            >
                              <Box sx={{ display: "flex", alignItems: "center" }}>
                                <Typography
                                  sx={{ color: "#4D5761", fontSize: "14px", fontWeight: 500 }}
                                >
                                  Show :
                                </Typography>
                                {/* <OutlinedInput inputProps={{ min: 5, max: 30, step: 5 }} value={rowsPerPage} onChange={(e) => setRowsPerPage(e.target.value)} type='number' sx={{ height: '40px', width: '100px', ml: 2, borderRadius: '8px' }} /> */}
                                <Box
                                  onClick={(e) => setshowAnchorEl(e.currentTarget)}
                                  sx={{
                                    width: "95px",
                                    height: "40px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    border: "1px solid #E5E7EB",
                                    borderRadius: "6px",
                                    ml: 2,
                                    "&:hover": { cursor: "pointer" },
                                  }}
                                >
                                  <Typography
                                    sx={{ fontSize: "15px" }}
                                    display="flex"
                                    alignItems="center"
                                    justifyContent="space-between"
                                  >
                                    {rowsPerPage} rows{" "}
                                    <NumberInputIcon style={{ paddingLeft: "5px" }} />
                                  </Typography>
                                </Box>
                              </Box>
                              <Pagination
                                size="medium"
                                page={currentPage}
                                count={paginationData?.last_page}
                                onChange={(e, value) => setCurrentPage(value)}
                                shape="rounded"
                                renderItem={(item) => (
                                  <PaginationItem
                                    slots={{ previous: PreviousIcon, next: NextIcon }}
                                    {...item}
                                  />
                                )}
                              />
                            </Box>
                          )}
                        </>
                      </Box>
                      <Menu
                        sx={{ m: 0.5 }}
                        open={open}
                        anchorEl={anchorEl}
                        onClose={() => setAnchorEl(null)}
                      >
                        <MenuItem>
                          <TypographyDefault
                            py={0.5}
                            sx={{
                              fontWeight: "500 !important",
                              color: "#1F2A37 !important",
                              display: "flex",
                            }}
                            onClick={() => DownloadReport("csv")}
                          >
                            <CsvIcon width={40} /> Download as CSV file
                          </TypographyDefault>
                        </MenuItem>
                        <MenuItem>
                          <TypographyDefault
                            py={0.5}
                            sx={{
                              fontWeight: "500 !important",
                              color: "#1F2A37 !important",
                              display: "flex",
                            }}
                            onClick={() => DownloadReport("pdf")}
                          >
                            <PdfIcon width={40} />
                            Download as PDF file
                          </TypographyDefault>
                        </MenuItem>
                      </Menu>
                      <Menu
                        sx={{ m: 0.5 }}
                        open={sortOpen}
                        anchorEl={sortAnchorEl}
                        onClose={() => setSortAnchorEl(null)}
                      >
                        <MenuItem
                          sx={{ backgroundColor: sortData == "recent" ? "#eff3f5" : "" }}
                          onClick={() => {
                            setSortData("recent");
                            setSortAnchorEl(null);
                          }}
                        >
                          <Typography py={0.3}>Latest Arrival first</Typography>
                        </MenuItem>
                        <MenuItem
                          sx={{ backgroundColor: sortData == "old" ? "#eff3f5" : "" }}
                          onClick={() => {
                            setSortData("old");
                            setSortAnchorEl(null);
                          }}
                        >
                          <Typography py={0.3}>Oldest Arrival First</Typography>
                        </MenuItem>
                        {/* <MenuItem>
                          <Typography py={.3}>Most Visitors First</Typography>
                        </MenuItem>
                        <MenuItem>
                          <Typography py={.3}>Least Visitors First</Typography>
                        </MenuItem> */}
                      </Menu>
                      <Menu
                        sx={{ m: 0.5 }}
                        open={filterOpen}
                        anchorEl={filterAnchorEl}
                        onClose={() => setFilterAnchorEl(null)}
                      >
                        <MenuItem>
                          <Checkbox icon={<CheckboxIcon />} />
                          <Typography sx={{ mr: 3 }}>Management</Typography>
                        </MenuItem>
                        <MenuItem>
                          <Checkbox icon={<CheckboxIcon />} />
                          <Typography>Operations</Typography>
                        </MenuItem>
                        <MenuItem>
                          <Checkbox icon={<CheckboxIcon />} />
                          <Typography>Ground Staff</Typography>
                        </MenuItem>
                      </Menu>
                
                      <Menu
                        sx={{ m: 0.5 }}
                        open={showOpen}
                        anchorEl={showAnchorEl}
                        onClose={() => setshowAnchorEl(null)}
                        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                        transformOrigin={{ vertical: "top", horizontal: "left" }}
                      >
                        <MenuItem
                          onClick={() => {
                            setRowsPerPage(10);
                            setshowAnchorEl(null);
                          }}
                        >
                          <Typography>10 rows</Typography>
                        </MenuItem>
                        <MenuItem
                          onClick={() => {
                            setRowsPerPage(20);
                            setshowAnchorEl(null);
                          }}
                        >
                          <Typography>20 rows</Typography>
                        </MenuItem>
                        <MenuItem
                          onClick={() => {
                            setRowsPerPage(30);
                            setshowAnchorEl(null);
                          }}
                        >
                          <Typography>30 rows</Typography>
                        </MenuItem>
                        <MenuItem
                          onClick={() => {
                            setRowsPerPage(40);
                            setshowAnchorEl(null);
                          }}
                        >
                          <Typography>40 rows</Typography>
                        </MenuItem>
                        <MenuItem
                          onClick={() => {
                            setRowsPerPage(50);
                            setshowAnchorEl(null);
                          }}
                        >
                          <Typography>50 rows</Typography>
                        </MenuItem>
                      </Menu>
                
                      <Dialog open={openStatusModal} onClose={() => setOpenStatusModal(false)}>
                        <DialogTitle>
                          {newStatus ? "Activate User?" : "Deactivate User?"}
                        </DialogTitle>
                      
                        <DialogContent>
                          Are you sure you want to {newStatus ? "activate" : "deactivate"} this User?
                        </DialogContent>
                      
                        <DialogActions>
                          <Button onClick={() => setOpenStatusModal(false)}>Cancel</Button>
                      
                          <Button
                            color={newStatus ? "primary" : "error"}
                            onClick={() => handleConfirmToggle()}
                          >
                            Confirm
                          </Button>
                        </DialogActions>
                      </Dialog>
                    
              </TabPanel>
            )}
          </>
        )}
      </Box>
    </>
  );
};

export default ViewOrganization;
